const IMAGES = {
  5: require("../img/learning-app.png"),
  2: require("../img/ubb-se.png"),
  1: require("../img/stockpulse.png"),
  0: require("../img/merch-story.png"),
  4: require("../img/softopia-project.png"),
  3: require("../img/interactive-learning-app.png"),
  6: require("../img/personal-portofolio.png"),
};

export default IMAGES;
